import { Data, TransformsList } from 'cio/utils/analytics/transforms';

type UserFlagFeatureData = {
  feature: string;
  toggled: boolean;
};

const Transforms: TransformsList = {
  featureToggled(data: Data & UserFlagFeatureData) {
    return {
      Feature: data.feature,
      'Toggled On': data.toggled,
    };
  },
};

export default Transforms;
